<template>
    <div class="page-wrapper">
        <h3 class="heading">{{page.title}}</h3>
    </div>
</template>

<script>

    import _find from 'lodash/find'

    export default {
        name: 'PageComponent',
        data () {
            return {
                page: {},
                params: {
                    title: '',
                    description: '',
                    descriptionTwitter: '',
                    titleTwitter: '',                
                    descriptionFacebook: '',
                    titleFacebook: '',
                    image: '',
                    imageTwitter: '',
                    imageFacebook: '',
                    linkCanonical: ''
                }
            }
        },
        head: {
            title: function () {
                return {
                    inner: this.params.title,
                    separator: ' '
                }
            },
            meta: function () {
                return [
                    { n: 'description', c: this.params.description},
                    { n: 'keywords', c: this.params.keywords},
                    { n: 'twitter:title', c: this.params.titleTwitter},
                    { n: 'twitter:description', c: this.params.descriptionTwitter},
                    { n: 'twitter:image', c: `${url}/uploads/${this.params.imageTwitter}`},
                    { p: 'og:title', c: this.params.titleFacebook },
                    { p: 'og:description', c: this.params.descriptionFacebook},
                    { p: 'og:image', c: `${url}/uploads/${this.params.imageFacebook}`},
                    { p: 'og:url', h: `${url}`}
                ]
            },
            link: function() {
                return [
                    { r: 'canonical', h: this.params.linkCanonical}
                ]
            }
        },
        methods: {
            fetchData: function () {
                const pages = this.$store.getters.getPages
                const page = _find(pages, {slug: this.$route.params.pageSlug})
                this.page = page

                this.params = this.formatMeta(this.page)
                this.$nextTick( () => {
                    this.$emit('updateHead')
                })
            }
        }
    }
</script>
